var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('left-navigation'),_c('top-navigation'),_c('v-main',[_c('v-container',{staticClass:"mt-8",attrs:{"fluid":""}},[_c('router-view')],1),_c('bottom-navigation')],1),_c('snack-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }